export default "__VITE_ASSET__C6v4zk8L__"